import { Box, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

import MessageInput from "./MessageInput";
import ThreadViewLayout from "./ThreadViewLayout";
import { Leader, LearnerInfo, SectionInfo } from "./types";

interface NewThreadViewProps {
  section: SectionInfo;
  classPostUid?: string;
  learningAssignmentClassPostUid?: string;
  postTitle: string;
  learner: LearnerInfo;
  leader: Leader | null;
  onBack: () => void;
  onClose: () => void;
  onThreadCreated: (threadUid: string) => void;
}

export default function NewThreadView({
  section,
  classPostUid,
  learningAssignmentClassPostUid,
  postTitle,
  learner,
  leader,
  onBack,
  onClose,
  onThreadCreated,
}: NewThreadViewProps) {
  const { t } = useTranslation(
    "learnerApp\\MessageTeacherButton\\NewThreadView",
  );

  return (
    <ThreadViewLayout
      section={section}
      leader={leader}
      postTitle={postTitle}
      onBack={onBack}
      onClose={onClose}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2.4rem",
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: "center" }}
        >
          {t("Ask your teacher a question about this post.")}
        </Typography>
      </Box>

      <MessageInput
        sectionUid={section.uid}
        classPostUid={classPostUid}
        learningAssignmentClassPostUid={learningAssignmentClassPostUid}
        learnerUid={learner.uid}
        learnerName={learner.name ?? ""}
        onMessageSent={() => {}}
        onThreadCreated={onThreadCreated}
      />
    </ThreadViewLayout>
  );
}
